import React, { useLayoutEffect } from "react";
import { Container } from "./styles";

import Lottie from 'react-lottie';
import CaraRuleta from 'assets/lotties/CaraRuleta.json';
import useResponsive from "utils/hooks/useResponsive";

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: CaraRuleta
};

const Loader = () => {

  const { isMobile } = useResponsive()

  const width = isMobile ? 120 : 200

  useLayoutEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => document.body.style.overflow = 'visible'
  }, [])

  return (
    <Container>
      <Lottie options={defaultOptions} width={width} isClickToPauseDisabled />
    </Container>
  );
};

export default Loader;
